module.exports = __webpack_public_path__ + "img/top.1962c01e.png";